import React, { useEffect, useState } from "react";
import DashboardCard from "../../Components/Card/DashboardCard";
import { useSelector } from "react-redux";
import { CircularProgress, Grid, Box, Container, Stack, Typography, Chip } from "@mui/material";
import configServ from "../../services/config";
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from "@mui/icons-material/People";
import { useNavigate } from "react-router-dom";
import AttendanceChart from "../../Components/Chart/AttendanceChart";
import PunchLogsDashboard from "../../Components/Chart/PunchLogsDashboard";
import Dashboards from "../../HR_Parts/Dashboards";

//FUNCTION
function Dashboard() {
  //#region code
  const { user_id, company_id, is_super } = useSelector((state) => state.GlobalVariables);
  const navigate = useNavigate();

  const [count, setCount] = useState({});
  const [sampleData, setSampleData] = useState(null);
  const [currentWorkingEmployees, setCurrentWorkingEmployees] = useState(null);

  const fetchDashboardCount = async () => {
    try {
      if (user_id === null) {
        navigate("/");
      }
      const result = await configServ.getDashboardCount({ user_id, company_id });
      setCount(result);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchAttendanceChartData = async () => {
    try {
      const result = await configServ.getAttendanceChart({ user_id, company_id, filter: "last_7_days" });
      setSampleData(result);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchCurrentWorkingEmployeesData = async () => {
    try {
      const result = await configServ.currentWorkingEmployees({ user_id, company_id, filter: "last_7_days" });
      setCurrentWorkingEmployees(result);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchDashboardCount();
    fetchAttendanceChartData();
    fetchCurrentWorkingEmployeesData();
  }, []);

  const cardData = [
    {
      title: "SITES",
      number: count.subscription,
      icon: <PeopleIcon sx={{ color: "#6270e4", fontSize: 26 }} />,
      link: "/account-master-entry/customers",
      state: {
        type: "Standard",
      },
    },
  ];
  //#endregion

  const todayLabel = new Date().toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  return (
    <>
      <Box sx={{ bgcolor: "#f4f5f9", width: "100%" }}>
        <Container maxWidth="xl" sx={{ py: 4 }}>

          {/* Page header */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            spacing={2}
            sx={{ mb: 3 }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "#6270e4",
                }}
              >
                <DashboardIcon sx={{ color: "#fff", fontSize: 24 }} />
              </Box>
              <Box>
                <Typography variant="h5" fontWeight={700} color="#1a1f36" lineHeight={1.2}>
                  Dashboard
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Overview of your organization's activity
                </Typography>
              </Box>
            </Stack>

            <Chip
              label={todayLabel}
              variant="outlined"
              sx={{
                bgcolor: "#fff",
                borderColor: "#e0e3ec",
                fontWeight: 500,
                color: "#4a4f66",
              }}
            />
          </Stack>

          {/* Summary cards - original theme kept, only alignment & responsiveness fixed */}
          <Grid
            container
            alignItems="stretch"
            justifyContent={{ xs: "center", sm: "flex-start" }}
            spacing={2}
            sx={{
              backgroundColor: "#6270e4",
              width: "100%",
              m: 0,
              p: { xs: 1.5, sm: 2 },
              borderRadius: "12px",
              mb: 4,
              py: { xs: 2, sm: 3 },
            }}
          >
            {cardData.map((item, index) => (
              <Grid key={index} size={{ xs: 6, sm: 6, md: 4, lg: 3 }} >
                <DashboardCard index={index} data={item} onClick={item.onClick} />
              </Grid>
            ))}
          </Grid>

          {/* Charts */}
          <Grid container spacing={3} sx={{ mt: 0.5 }}>
            <Grid item xs={12} md={6}>
              <Box sx={{ height: "100%" }}>
                <AttendanceChart apiResponse={sampleData} />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ height: "100%" }}>
                <PunchLogsDashboard apiResponse={currentWorkingEmployees} />
              </Box>
            </Grid>
          </Grid>

        </Container>
      </Box>
    </>
  );
}

export default Dashboard;